// extracted by mini-css-extract-plugin
module.exports = {"body":"Text_body__7nC_t","body1":"Text_body1__2s7Kj","body2":"Text_body2__0B_xN","bodyLarge":"Text_bodyLarge__zNEWg"};